export type TreemapSubtopicSelection = {
  topicSlug: string;
  subtopicSlug: string;
  subtopicDisplay: string;
};

export function isGeneralSubtopicSlug(subtopicSlug: string, topicSlug: string): boolean {
  return subtopicSlug === `${topicSlug}__general` || subtopicSlug.endsWith("__general");
}

/** Match accepted chunks assigned to a topic/subtopic (or topic-only for general bucket). */
export function chunkMatchesSubtopic(
  chunk: {
    action: string;
    resolved?: Array<{ slug: string; subtopic?: string | undefined }> | undefined;
  },
  topicSlug: string,
  subtopicSlug: string,
): boolean {
  if (chunk.action !== "accept") return false;

  for (const resolved of chunk.resolved ?? []) {
    if (resolved.slug !== topicSlug) continue;
    if (isGeneralSubtopicSlug(subtopicSlug, topicSlug)) {
      if (!resolved.subtopic) return true;
    } else if (resolved.subtopic === subtopicSlug) {
      return true;
    }
  }

  return false;
}

export function filterChunksForSubtopic<
  T extends {
    action: string;
    resolved?: Array<{ slug: string; subtopic?: string | undefined }> | undefined;
  },
>(chunks: T[], topicSlug: string, subtopicSlug: string): T[] {
  return chunks.filter((chunk) => chunkMatchesSubtopic(chunk, topicSlug, subtopicSlug));
}
